// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_fex.actions.go

export const LIST_FEX_METADATA =
  "mondoo.policy.FindingsExchange.ListFexMetadata";
